import { LocationOption } from '../types/Location';
import { getApiHeaders } from '../utils/apiHeaders';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL
const TRAVEL_API_PATH = '/api/travel';

export function loadLocations(inputValue: string): Promise<LocationOption[]>;

export function loadLocations(
  inputValue: string,
  callback: (options: LocationOption[]) => void
): void;

export function loadLocations(
  inputValue: string,
  callback?: (options: LocationOption[]) => void
): Promise<LocationOption[]> | void {
  if (!inputValue || inputValue.length < 3) {
    if (callback) {
      callback([]);
      return;
    }
    return Promise.resolve([]);
  }

  const url = `${API_BASE_URL}${TRAVEL_API_PATH}/locations?search=${encodeURIComponent(inputValue)}`;
  const promise = fetch(url, {
    headers: getApiHeaders('none')
  })
    .then(res => {
      if (!res.ok) throw new Error('Failed to fetch locations');
      return res.json() as Promise<LocationOption[]>;
    });

  if (callback) {
    promise.then(data => callback(data)).catch(() => callback([]));
    return;
  }

  return promise;
}

export function loadAirportLocations(inputValue: string): Promise<LocationOption[]>;
export function loadAirportLocations(
  inputValue: string,
  callback: (options: LocationOption[]) => void
): void;
export function loadAirportLocations(
  inputValue: string,
  callback?: (options: LocationOption[]) => void
): Promise<LocationOption[]> | void {
  if (callback) {
    loadLocations(inputValue, (opts) => {
      const filtered = opts.filter(o => o.type === 'airport');
      callback(filtered);
    });
    return;
  }
  return loadLocations(inputValue).then(opts =>
    opts.filter(o => o.type === 'airport')
  );
}

export function loadCityLocations(inputValue: string): Promise<LocationOption[]>;
export function loadCityLocations(
  inputValue: string,
  callback: (options: LocationOption[]) => void
): void;
export function loadCityLocations(
  inputValue: string,
  callback?: (options: LocationOption[]) => void
): Promise<LocationOption[]> | void {
  if (callback) {
    loadLocations(inputValue, (opts) => {
      const filtered = opts.filter(o => o.type === 'city');
      callback(filtered);
    });
    return;
  }
  return loadLocations(inputValue).then(opts =>
    opts.filter(o => o.type === 'city')
  );
}

export type ActivityCityOption = LocationOption & { cityId: number; countryId: number; countryName?: string | null };
export async function loadActivityCityLocations(inputValue: string): Promise<ActivityCityOption[]> {
  if (!inputValue || inputValue.length < 2) return [];
  const response = await fetch(`${API_BASE_URL}${TRAVEL_API_PATH}/locations/activity-cities?search=${encodeURIComponent(inputValue)}`, { headers: getApiHeaders('none') });
  if (!response.ok) throw new Error('Failed to fetch activity locations');
  const rows = await response.json();
  return rows.map((row: any) => ({ value: String(row.cityId), label: `${row.cityName}${row.countryName ? `, ${row.countryName}` : ''}`, type: 'city', cityId: Number(row.cityId), countryId: Number(row.countryId), countryName: row.countryName }));
}
export const loadActivityCountries = async () => { const response = await fetch(`${API_BASE_URL}${TRAVEL_API_PATH}/locations/activity-countries`, { headers: getApiHeaders('none') }); if (!response.ok) throw new Error('Failed to fetch countries'); return response.json() as Promise<Array<{ countryId: number; countryName: string }>>; };
export const createActivityCity = async (countryId: number, cityName: string) => { const response = await fetch(`${API_BASE_URL}${TRAVEL_API_PATH}/locations/activity-cities`, { method: 'POST', headers: getApiHeaders('json'), body: JSON.stringify({ countryId, cityName }) }); if (!response.ok) throw new Error((await response.json().catch(() => ({}))).error || 'Failed to add city'); return response.json() as Promise<{ cityId: number; cityName: string; countryId: number; countryName: string; cityCode: string | null }>; };
